import Vue from 'vue'
import Component from 'vue-class-component'
import authStore from '@/store/auth/auth-store'

@Component({
  name: 'logout',
})
export default class Logout extends Vue {
  mounted (): void {
    this.logout()
/* 
    this.$store.subscribe((mutation, state) => {
      console.log('Logout mutation: type = %j', mutation.type)
      if (mutation.type === 'auth/purgeUser') {
        this.$router.push('/')
      }
    })
 */    
  }

  protected logout (): void {
    authStore.dispatchLogout()
  }
}
